import queryString from 'query-string';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  ADMIN: {
    QUERY_ADMIN_TASK_GROUPS: (filter) => ({ filter }),
    API: {
      QUERY_ADMIN_TASK_GROUPS: apiResourceActionCreator('taskGroups')
    }
  }
})

export const apiAction = (authToken, filter) => commonApiActions.authenticated.get(`${API_ENDPOINT}/taskGroups?${queryString.stringify(filter)}`, authToken, actions.admin.api.queryAdminTaskGroups);

function* queryAdminTaskGroups(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.filter));
}

const configuration = {
  name: 'queryAdminTaskGroups',
  action: actions,
  sagas: queryAdminTaskGroups,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingTaskGroup: true,
      error: null
    }),
    success: (state, action) => ({
      ...state,
      adminTaskGroups: action.payload.taskGroups,
      isFetchingTask: false,
      error: null
    }),
    failed: (state, action) => ({
      ...state,
      isFetchingTaskGroup: false,
      error: action.payload.error
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/queryAdminTaskGroups.js